var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5543_13226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3386 25.7781L37.3386 25.7781C37.4135 26.2241 37.7999 26.5396 38.2375 26.5396C38.2876 26.5396 38.3385 26.5355 38.3896 26.5269L38.3896 26.5269C38.8866 26.4434 39.2218 25.9729 39.1384 25.4758C38.4427 21.334 35.3642 17.9794 31.2956 16.9292C30.8071 16.8031 30.3099 17.0968 30.1839 17.5847L30.1839 17.5848C30.0582 18.0725 30.3517 18.5702 30.8396 18.6962L30.8646 18.5993L30.8396 18.6962C34.2112 19.5664 36.7622 22.3463 37.3386 25.7781Z",
    fill: "url(#paint0_linear_5543_13226)",
    stroke: "url(#paint1_linear_5543_13226)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7174 51.8689L8.64669 51.7982L8.7174 51.8689L16.8425 43.7438L16.7718 43.6731L16.8425 43.7438C17.475 43.1112 17.8236 42.2696 17.8236 41.375C17.8236 40.7935 17.6761 40.2343 17.3989 39.7402L19.9326 37.2066C22.3822 39.3566 25.5906 40.6625 29.0987 40.6625C36.7702 40.6625 43.0112 34.4214 43.0112 26.75C43.0112 19.0786 36.7702 12.8375 29.0987 12.8375C21.4271 12.8375 15.1861 19.0786 15.1861 26.75C15.1861 30.2581 16.492 33.4664 18.642 35.916L16.1083 38.4497C15.6143 38.1726 15.0552 38.025 14.4736 38.025C13.579 38.025 12.7375 38.3735 12.1049 39.0061L3.97987 47.1311C3.34727 47.7637 2.99863 48.6053 2.99863 49.5C2.99863 50.3946 3.34727 51.2362 3.97986 51.8689C4.63299 52.522 5.4911 52.8484 6.34864 52.8484C7.20618 52.8484 8.06428 52.5219 8.7174 51.8689ZM15.5519 42.4534L15.5519 42.4534L7.4269 50.5783L7.49761 50.649L7.4269 50.5783C6.83232 51.1729 5.86467 51.1727 5.27026 50.5784C4.98211 50.2902 4.82363 49.9075 4.82363 49.5C4.82363 49.0924 4.9821 48.7098 5.27026 48.4217L5.19956 48.351L5.27027 48.4217L13.3953 40.2966C13.3953 40.2966 13.3953 40.2966 13.3953 40.2966C13.6835 40.0086 14.0661 39.85 14.4735 39.85C14.881 39.85 15.2637 40.0085 15.5519 40.2967L15.5519 40.2968C15.8402 40.5848 15.9986 40.9674 15.9986 41.375C15.9986 41.7825 15.8402 42.1652 15.5519 42.4534ZM29.0987 14.6625C35.7636 14.6625 41.1862 20.085 41.1862 26.75C41.1862 33.415 35.7636 38.8375 29.0987 38.8375C22.4337 38.8375 17.0111 33.415 17.0111 26.75C17.0111 20.085 22.4337 14.6625 29.0987 14.6625Z",
    fill: "url(#paint2_linear_5543_13226)",
    stroke: "url(#paint3_linear_5543_13226)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5011 11.9963L49.5011 11.9964L49.5011 11.9963ZM49.5011 11.9963C49.4995 11.985 49.497 11.9649 49.4934 11.9466C49.4902 11.9303 49.485 11.9115 49.4828 11.9027L49.4828 11.9025M49.5011 11.9963L49.4828 11.9025M49.4828 11.9025C49.4823 11.9006 49.4817 11.8982 49.4811 11.8954C49.4788 11.8858 49.4755 11.8721 49.4719 11.8602L49.4719 11.8601M49.4828 11.9025L49.4719 11.8601M49.4719 11.8601C49.4682 11.8479 49.4633 11.8344 49.4598 11.8249C49.4588 11.8221 49.4579 11.8196 49.4572 11.8177L49.4571 11.8174M49.4719 11.8601L49.4571 11.8174M49.4571 11.8174C49.4539 11.8085 49.448 11.7909 49.4417 11.7756L49.4416 11.7753M49.4571 11.8174L49.4416 11.7753M49.4416 11.7753C49.4368 11.7639 49.431 11.7518 49.4268 11.743C49.4256 11.7406 49.4246 11.7385 49.4238 11.7367L49.3334 11.7795M49.4416 11.7753L49.4033 11.6945M49.4033 11.6945L49.4034 11.6948C49.4102 11.7075 49.4164 11.7209 49.4212 11.7311C49.4221 11.7332 49.4231 11.7353 49.4239 11.7371L49.3334 11.7795M49.4033 11.6945C49.3963 11.6814 49.3858 11.6647 49.3824 11.659L49.3822 11.6586M49.4033 11.6945L49.3822 11.6586M49.3334 11.7795L49.33 11.7722C49.3252 11.762 49.3205 11.7518 49.3152 11.7418L49.3334 11.7795ZM49.3822 11.6586C49.3811 11.6567 49.3798 11.6545 49.3783 11.6521C49.3728 11.6426 49.3651 11.6296 49.3572 11.6178C49.35 11.6071 49.3411 11.5954 49.3348 11.5871C49.3329 11.5846 49.3313 11.5824 49.3299 11.5806L49.3297 11.5802M49.3822 11.6586L49.3297 11.5802M49.3297 11.5802C49.329 11.5793 49.3278 11.5777 49.3262 11.5755M49.3297 11.5802L49.3262 11.5755M38.5671 0.821126C38.5355 0.798429 38.5018 0.776732 38.4657 0.75746L38.4657 0.757456L38.4649 0.757009L38.4577 0.753517L38.4575 0.753387L38.457 0.75315C38.4233 0.735668 38.3887 0.720754 38.3541 0.707862L38.3541 0.707856L38.353 0.707486L38.3511 0.706764L38.5671 0.821126ZM38.5671 0.821126C38.5732 0.825529 38.5799 0.830612 38.5848 0.834325M38.5671 0.821126L38.5848 0.834325M38.3323 0.699915C38.2951 0.687106 38.2559 0.67582 38.2148 0.667652C38.2148 0.667664 38.2149 0.667676 38.2149 0.667688L38.3323 0.699915ZM38.3323 0.699915C38.3323 0.699921 38.3324 0.699926 38.3324 0.699932L38.2998 0.794484L38.3323 0.699915ZM38.5893 0.837751L38.5893 0.837753C38.6192 0.860629 38.6496 0.885788 38.6784 0.914262L38.5893 0.837751ZM38.5893 0.837751L38.5887 0.837312M38.5893 0.837751L38.5887 0.837312M38.5887 0.837312C38.5876 0.836487 38.5863 0.835471 38.5848 0.834325M38.5887 0.837312L38.5848 0.834325M49.3262 11.5755C49.3209 11.5682 49.3115 11.5552 49.3041 11.5462M49.3262 11.5755L49.3041 11.5462M49.3041 11.5462C49.287 11.5254 49.2691 11.5058 49.2511 11.4874C49.2497 11.4857 49.2469 11.4825 49.2433 11.479M49.3041 11.5462L49.2269 11.6098C49.2115 11.591 49.195 11.573 49.178 11.5556C49.1772 11.5548 49.1765 11.554 49.1757 11.5531C49.1749 11.5522 49.1741 11.5512 49.1732 11.5504L49.2439 11.4796L49.2433 11.479M49.2433 11.479C49.2428 11.4786 49.2423 11.4781 49.2418 11.4776M49.2433 11.479L49.2418 11.4776M49.2418 11.4776L38.6816 0.917313L49.2418 11.4776ZM38.2089 0.666647C38.1717 0.659522 38.1345 0.65536 38.0981 0.652874L38.0979 0.652857C38.0879 0.652202 38.0775 0.651625 38.0669 0.651273V0.651249L38.0647 0.651225L38.0563 0.650776L38.056 0.650756C38.0516 0.650475 38.0442 0.65 38.0362 0.65H11.2236C9.82432 0.65 8.68613 1.7883 8.68613 3.1875V38.1249C8.68613 38.6288 9.0947 39.0374 9.59863 39.0374C10.1026 39.0374 10.5111 38.6288 10.5111 38.1249V3.1875C10.5111 2.79474 10.8309 2.475 11.2236 2.475H37.1237V10.5C37.1237 11.8992 38.262 13.0375 39.6612 13.0375H44.5361C45.04 13.0375 45.4486 12.6289 45.4486 12.125C45.4486 11.6211 45.04 11.2125 44.5361 11.2125H39.6612C39.2684 11.2125 38.9487 10.8928 38.9487 10.5V3.7654L47.6862 12.5029V50.3125C47.6862 50.7053 47.3664 51.025 46.9737 51.025H12.0364C11.5325 51.025 11.1239 51.4336 11.1239 51.9375C11.1239 52.4414 11.5325 52.85 12.0364 52.85H46.9737C48.373 52.85 49.5112 51.7117 49.5112 50.3125V12.1252C49.5112 12.0949 49.5096 12.0648 49.5066 12.0351L38.2089 0.666647ZM38.6727 0.909376C38.6729 0.909515 38.6737 0.910143 38.6745 0.910871L38.6733 0.909853L38.6729 0.909517L38.6727 0.909381L38.6727 0.909376Z",
    fill: "url(#paint4_linear_5543_13226)",
    stroke: "url(#paint5_linear_5543_13226)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3549 25.75C34.3549 25.3041 34.0664 24.9 33.664 24.9H21.8458C21.4433 24.9 21.1549 25.3041 21.1549 25.75C21.1549 26.1959 21.4433 26.6 21.8458 26.6H33.664C34.0664 26.6 34.3549 26.1959 34.3549 25.75Z",
    fill: "url(#paint6_linear_5543_13226)",
    stroke: "url(#paint7_linear_5543_13226)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6835 29.9H23.8263C23.6307 29.9 23.4606 30.0043 23.3427 30.1591C23.2249 30.3137 23.1549 30.523 23.1549 30.75C23.1549 30.977 23.2249 31.1863 23.3427 31.3409C23.4606 31.4957 23.6307 31.6 23.8263 31.6H34.6835C34.8791 31.6 35.0492 31.4957 35.1671 31.3409C35.2849 31.1863 35.3549 30.977 35.3549 30.75C35.3549 30.523 35.2849 30.3137 35.1671 30.1591C35.0492 30.0043 34.8791 29.9 34.6835 29.9Z",
    fill: "url(#paint8_linear_5543_13226)",
    stroke: "url(#paint9_linear_5543_13226)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5543_13226",
    x1: 34.653,
    y1: 17,
    x2: 37.0372,
    y2: 29.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5543_13226",
    x1: 34.653,
    y1: 17,
    x2: 37.0372,
    y2: 29.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5543_13226",
    x1: 23.0049,
    y1: 12.9375,
    x2: 32.4215,
    y2: 63.8727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5543_13226",
    x1: 23.0049,
    y1: 12.9375,
    x2: 32.4215,
    y2: 63.8727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5543_13226",
    x1: 29.0986,
    y1: 0.75,
    x2: 44.5175,
    y2: 65.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5543_13226",
    x1: 29.0986,
    y1: 0.75,
    x2: 44.5175,
    y2: 65.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5543_13226",
    x1: 27.7549,
    y1: 25,
    x2: 27.7972,
    y2: 26.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5543_13226",
    x1: 27.7549,
    y1: 25,
    x2: 27.7972,
    y2: 26.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5543_13226",
    x1: 29.2549,
    y1: 30,
    x2: 29.3007,
    y2: 31.9837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5543_13226",
    x1: 29.2549,
    y1: 30,
    x2: 29.3007,
    y2: 31.9837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5543_13226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.254883 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefineIcon);
export default __webpack_public_path__ + "static/media/DefineIcon.7e23fa4874582b1a2b1080f6f10ab814.svg";
export { ForwardRef as ReactComponent };